const { APP_CONSTANTS } = window;
export const EVENT_DESCRIPTION_MAX_CHARACTERS = 750;
export const PAST_EVENT_SESSION = 'past-live-session';
export const LIVE_SESSION = 'live-session';
export const ON_DEMAND_CONTENT = 'on-demand';
export const EXTERNAL_LINK_ON_DEMAND_CONTENT_TYPE = 'url';
export const FILE_UPLOAD_ON_DEMAND_CONTENT_TYPE = 'file';
export const DEFAULT_SHOWN_SESSIONS = 20;
export const INVITED = 'Invited';
export const DECLINED_INVITATION = 'Declined Invitation';
export const REGISTERED = 'Registered';
export const ATTENDED = 'Attended';
export const ABSENT = 'Absent';
export const UNREGISTERED = 'Unregistered';

export const STATUS_TO_DISPLAY_NAME = {
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.INVITED]: INVITED,
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.DECLINED_INVITATION]: DECLINED_INVITATION,
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.REGISTERED]: REGISTERED,
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.UNREGISTERED]: UNREGISTERED,
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.ATTENDED]: ATTENDED,
  [APP_CONSTANTS.ACADEMY_EVENT_SESSION_USER_STATUSES.ABSENT]: ABSENT,
};
